import React from 'react';

import Button from 'components/UI/Button';
import Row from 'components/UI/Row';
import { useUrlBuilder } from 'hooks/useUrlBuilder';
import { Product } from 'models/product';

import { ModalOverflow, ModalContent } from './ModalProductExcluded.css';

export const ModalProductExcluded: React.ComponentType<{
  product: Product;
}> = ({ product: { category } }) => {
  const { localized, withTrailingSlash } = useUrlBuilder();
  return (
    <>
      <ModalContent data-cy="modal-product-excluded">
        <div>
          <Row justifyContent="center" margin="0 0 10px">
            Sorry, this item is not available in your region.
          </Row>
          <Row justifyContent="center" style={{ textAlign: 'center' }}>
            Continue discovering italist's luxury fashion offerings
          </Row>
          <Row justifyContent="center">
            or browse our&nbsp;
            <a href={localized()} style={{ textDecoration: 'underline' }}>
              homepage
            </a>
            .
          </Row>
          <Row justifyContent="center" margin="25px 0 0">
            <Button
              backgroundColor="#000000"
              border="none"
              borderRadius="2px"
              color="#FFFFFF"
              data-cy="button-product-excluded"
              fontSize="15px"
              height="40px"
              onClick={() => {
                window.location.href = withTrailingSlash(localized(category.url));
              }}
              type="submit"
              width="290px"
            >
              SHOP {category.name.toUpperCase()}
            </Button>
          </Row>
        </div>
      </ModalContent>
      <ModalOverflow />
    </>
  );
};
